import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as Service from "../services";
import makeData from "../services/makeData";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";

import { COLUMNS } from "../config/Transaction/columns";
import { addAfterLoginNotification } from "../../../components/Toast/utils/notifications";

interface AsyncState {
  isLoading: {
    brandData: boolean;
    brandsData: boolean;
    brandAdd: boolean;
    deleteBrand: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface TableState extends AsyncState {
  brandData: any;
  totalCount: Number;
  statusData: any;
  applicationOptions: any;
  addBrandRes: any;
  editProductRes: any;
  deleteBrandRes: any;
  isLogout: any;
  fullResponse: Array<any>;
  brandsData: Array<any>;
  rootReducer?: any;
  auth?: any;
  errorMsg?: any;
  userTableColumns: any;
}

const initialState: TableState = {
  isLoading: {
    brandData: true,
    brandsData: true,
    brandAdd: false,
    deleteBrand: false,
  },
  isSuccess: false,
  isError: false,
  brandData: null,
  statusData: null,
  applicationOptions: null,
  addBrandRes: {},
  editProductRes: null,
  deleteBrandRes: null,
  totalCount: NaN,
  isLogout: false,
  fullResponse: [],
  brandsData: [],
  errorMsg: null,
  userTableColumns: COLUMNS,
};

export const fetchAllBrands = createAsyncThunk(
  "brandData",
  async (data: any, thunkAPI) => {
    try {
      const res: any = await Service.getAllBrands();

      const madeData = makeData(res.data);

      return { madeData, fullResponse: res.data };
    } catch (error: any) {
      // thunkAPI.dispatch(resetLogout(error))
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addBrand = createAsyncThunk(
  "user/addBrandData",
  async (data: any, thunkAPI) => {
    try {
      return await Service.addBrand(data);
    } catch (error) {
      // thunkAPI.dispatch(resetLogout(error));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteBrand = createAsyncThunk(
  "user/deleteBrand",
  async (data: any, thunkAPI) => {
    try {
      return await Service.deleteBrand(data);
    } catch (error) {
      // thunkAPI.dispatch(resetLogout(error));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getColumns = createAsyncThunk(
  "getColumns",
  (data: any, thunkAPI) => {
    try {
      // const madeColsData = makeData(data);
      return data?.cols;
    } catch (error) {
      // thunkAPI.dispatch(resetLogout(error));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const brandSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    resetAddBrandRes: (state) => {
      state.addBrandRes = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchAllBrands.pending, (state, action: any) => {
        state.isLoading.brandData = true;
        state.isError = false;
        state.errorMsg = null;
      })
      .addCase(fetchAllBrands.fulfilled, (state, action: any) => {
        state.isLoading.brandData = false;
        state.isSuccess = true;
        state.isError = false;
        state.brandData = action.payload.madeData;
        state.fullResponse = action.payload.fullResponse;
        state.errorMsg = null;
      })
      .addCase(fetchAllBrands.rejected, (state, action: any) => {
        state.isLoading.brandData = false;
        state.isError = true;
        state.errorMsg = action.payload.errorMsg;
        state = {
          ...state,
          ...action.payload,
        };
      })

      .addCase(addBrand.pending, (state) => {
        state.isLoading.brandAdd = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.addBrandRes = null;
      })
      .addCase(addBrand.fulfilled, (state, action: any) => {
        addAfterLoginNotification("Brand Create successfully", "success");
        state.isLoading.brandAdd = false;
        state.isSuccess = true;
        state.isError = false;
        state.addBrandRes = action.payload ?? {};
      })
      .addCase(addBrand.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.brandAdd = false;
        state.isSuccess = false;
        state.isError = true;
        state.addBrandRes = null;
        state.errorMsg = action.payload.errorMsg;
      })

      // MODIFY_COLUMNS
      .addCase(getColumns.pending, (state) => {
        // state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.userTableColumns = initialState.userTableColumns;
      })
      .addCase(getColumns.fulfilled, (state, action: any) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.userTableColumns = action.payload;
      })
      .addCase(getColumns.rejected, (state) => {
        // state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.userTableColumns = initialState.userTableColumns;
      })

      .addCase(deleteBrand.pending, (state) => {
        state.isLoading.deleteBrand = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.deleteBrandRes = null;
      })
      .addCase(deleteBrand.fulfilled, (state, action: any) => {
        addAfterLoginNotification("Brand Deleted successfully", "success");
        state.isLoading.deleteBrand = false;
        state.isSuccess = true;
        state.isError = false;
        state.deleteBrandRes = action.payload;
      })
      .addCase(deleteBrand.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.deleteBrand = false;
        state.isSuccess = false;
        state.isError = true;
        state.deleteBrandRes = null;
        state.errorMsg = action.payload.errorMsg;
      });
  },
});
export const { resetAddBrandRes } = brandSlice.actions;
export default brandSlice.reducer;
